import { EventBus } from '@/services/eventBus'

/**
 * service class  to show popup messages at the top right side of page
 */

class Toast {
  SUCCESS_TYPE = 'success'
  ERROR_TYPE = 'error'
  INFO_TYPE = 'info'
  constructor () {
    this.toasts = []
  }

  showToast (type, message, options = {}) {
    EventBus.$emit('show-toast', type, message, options)
  }
}

export default new Toast()
